import React from 'react';
import Checkbox from '../Checkbox';
import Select from '../Select';
import styled from 'styled-components';
import ListHeader from '../List/Header';
import ListRow from '../List/Row';
import Notification from './Notification';
import { I18n } from 'react-redux-i18n';

const ServiceListContainer = styled.div`
  .checkboxFirstColumn {
    margin-left: 10px;
  }

  .label {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    text-transform: uppercase;
    color: #2b3d54;
    line-height: 14px;
    margin-bottom: 7px;
    font-size: 12px;
    font-family: Oswald;
    letter-spacing: 2px;
  }

  .serviceListCheckbox {
    width: 5%;
    justify-content: center;
  }

  .serviceListTitle {
    width: 35%;
    p {
      padding-left: 20px;
    }
  }

  .serviceListTitleHeader {
    width: 55%;
    padding-left: 30px;
  }

  .serviceListHour {
    width: 38%;
    justify-content: center;
    align-items: center;
  }

  .serviceListHourHeader {
    height: 100%;
    padding-left: 10%;
    border-left: 1px solid rgba(31, 43, 55, 0.1);
  }

  .itemList {
    display: flex;
    flex-direction: row;
    height: 50px;
  }

  .itemList > div {
    display: flex;
    align-items: center;
  }

  .serviceList {
    margin: 0px !important;
    overflow-y: auto;
    max-height: 450px;
    width: 100%;
  }

  .serviceListTitleItem {
    font-family: 'SFCompactText', sans-serif;
    color: black;
    font-size: 12px;
  }

  .serviceListTitleItemDisabled {
    color: grey;
    opacity: 0.5;
  }

  .serviceListSubTitle {
    font-weight: lighter;
    font-style: italic;
    font-family: 'SFCompactText', sans-serif;
  }

  .serviceListSubTitleRed {
    color: #e44b27;
    text-decoration: underline;
  }

  .serviceListSubTitleRed:hover {
    cursor: pointer;
  }

  .serviceListHeader {
    display: flex;
    justify-content: space-between;
    margin-top: 25px;
    align-items: flex-end;
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    .serviceListHeader {
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .serviceListHeader > div {
      width: 80% !important;
      margin-bottom: 20px;
    }
  }

  .zoneItemIcon {
    margin-left: 18px;
    margin-right: 31px;
    color: ${(props) => props.theme.colors['terra-cotta']};
  }

  .zoneItemIconDisabled {
    margin-left: 18px;
    margin-right: 26px;
    color: #868e96;
    width: 17px;
    height: 17px;
  }

  .serviceStatusItem {
    width: 28%;
    font-family: 'SFCompactText';
    justify-content: center;
    font-size: 12px;
  }

  .notavailable {
    opacity: 0.5;
  }

  .available {
    color: ${(props) => props.theme.colors['terra-cotta']};
  }

  .horizontalLine {
    width: 12px;
    height: 2px;
    background-color: ${(props) => props.theme.colors.dark};
  }

  a {
    color: inherit;
    text-decoration: none;
  }
`;

const ServiceList = ({
  options,
  notifications,
  newsletter,
  newsletterHour,
  onChangeSelect,
  onChangeCheckbox
}) => (
  <ServiceListContainer>
    <ListHeader
      columns={[
        {
          name: I18n.t('admin.services.availableServices'),
          length: '35%'
        },
        {
          name: I18n.t('admin.services.access'),
          length: '27%',
          center: true
        },
        {
          name: I18n.t('admin.services.realTimeNotification'),
          length: '38%',
          center: true
        }
      ]}
    />

    <div className="serviceList">
      {notifications.map((notification, index) => (
        <ListRow key={`serviceRow-${index}`} dark={index % 2 === 0}>
          <div className="serviceListTitle">
            <p className="serviceListTitleItem">{notification.name}</p>
          </div>
          <div className="serviceStatusItem">
            <Notification notification={notification} />
          </div>
          <div className="serviceListHour">
            {!notification.disabled &&
              notification.is_active &&
              (notification.email_notifications ? (
                <Checkbox
                  checked={notification.live_notifications}
                  onChange={() => onChangeCheckbox(notification.id)}
                />
              ) : (
                <div className="horizontalLine" />
              ))}
          </div>
        </ListRow>
      ))}
    </div>

    <div className="serviceListHeader">
      <div className="selectNewsletter">
        <Select
          minWidth="auto"
          label={I18n.t('admin.services.newsletter')}
          onChange={(selectedOption) =>
            onChangeSelect('newsletter', selectedOption.value)
          }
          dropdownProps={{
            styles: `margin-left:-25px`
          }}
          value={newsletter}
          options={options.newsletter}
        />
      </div>

      <div className="selectHour">
        <Select
          minWidth="50px"
          label={I18n.t('admin.services.newsletterHour')}
          onChange={(selectedOption) =>
            onChangeSelect('newsletterHour', selectedOption.value)
          }
          dropdownProps={{
            styles: `margin-left:-25px;`
          }}
          value={newsletterHour}
          options={options.reception}
        />
      </div>
    </div>
  </ServiceListContainer>
);

export default ServiceList;
